module.exports = __webpack_public_path__ + "static/media/baseball.14358247.svg";